import { apis, apiHolder, inWindow } from 'api';
import { config } from 'env_def';
const SHOW_OLD = 'show_old';
const storeApi = apiHolder.api.getDataStoreApi();
const webmailApi = apiHolder.api.requireLogicalApi(apis.webmailApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const trackMap = {
    NeteaseQiYeMail: 'qiye',
    QQMail: 'qq',
    '163Mail': '163',
    Others: 'other',
};
const ACTIVITY_STAT = 'activity_stat';
const getStore = (key) => {
    const result = storeApi.getSync(key);
    if (result.suc && result.data != null) {
        return result.data;
    }
    return null;
};
export const getShowOld = () => {
    const result = storeApi.getSync(SHOW_OLD);
    if (result.suc && result.data != null) {
        return result.data;
    }
    return '2';
};
export const joinWebmailActivity = (tid) => {
    const isWebmail = inWindow() && config('profile') ? config('profile').toString().includes('webmail') : false;
    const id = getStore(ACTIVITY_STAT) || '';
    if (isWebmail && id !== '') {
        webmailApi.doInvokeActivity(tid, +id);
    }
};
export const getEmailSuffix = (email) => {
    if (email === null || email === '') {
        return [];
    }
    var result = [email.substring(0, email.indexOf('@')), email.substring(email.indexOf('@') + 1, email.length)];
    return result;
};
export const sendAddAccountTrack = (way, accountType, result, failReason) => {
    trackApi.track('pcMail_click_LoginDetailPage_agent', {
        way,
        type: trackMap[accountType],
        bindResult: result,
        failReason: result === 'fail' ? failReason || '' : null,
    });
};
